/* eslint-disable react/jsx-handler-names */
import { useNavigate } from "react-router-dom";
import PageTitle from "components/atoms/PageTitle";
import { useBreakpoint } from "hooks/useBreakpoint";

import "./styles.sass";

const Header = () => {
  const navigate = useNavigate();
  const { isDesktop } = useBreakpoint();

  const handleBack = () => {
    navigate(-1);
  };
  return (
    <div className="FWHeader">
      <PageTitle
        title="menu.left.wheel"
        onBack={isDesktop ? null : handleBack}
      />
    </div>
  );
};

export default Header;
